import css from 'styled-jsx/css';
import { colors } from '../../theme/theme';

const style = css`
  .icon {
    width: 16px;
    height: 16px;
    margin-left: 4px;
  }
  .link-wrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .link-label {
    color: ${colors.blue};
    font-size: 16px;
  }
`;

export default style;
